import React, { useRef, useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Peer from 'simple-peer';
import styles from "./meeting.module.scss";
import Images from "../../../../assets/Images";
import axios from "axios";
// import CodeEditor from "./codeEditor";
import {
  Mic,
  MicOff,
  Video,
  VideoOff,
  PhoneOff,
} from "lucide-react";
import { Dialog } from "@mui/material";
import { getInterviewQuestion } from "store/common/common-action";
// import InterviewEvaluation from "./interviewEvaluation";
import { APIConstant } from "services/api-constant";
import JitsiMeeting from "./JitsiMeeting";
import Popup from "components/minor/popup/popup";
import AskOko from "./askOko";
import { apiWsUrl } from '../../../../services/config';
const API = apiWsUrl;
const useQuery = () => new URLSearchParams(useLocation().search);
function safeSend(ws, data) {
  if (!ws) return;

  if (ws.readyState === WebSocket.OPEN) {
    ws.send(JSON.stringify(data));
  } else if (ws.readyState === WebSocket.CONNECTING) {
    console.warn("WS not ready, retrying...");
    setTimeout(() => safeSend(ws, data), 500);
  } else {
    console.error("WS is closed, cannot send", ws.readyState);
  }
}
const StartMeetingSession = () => {
  const transcriptRef = useRef("");
  const navigate = useNavigate();
  const selectedQuestionsRef = useRef([]);
  const [open, setOpen] = React.useState(false);
  const query = useQuery();
  const user = query.get('clientId');
   const chatEndRef = useRef(null);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const localVideo = useRef();
  const remoteVideo = useRef();
  const recognitionRef = useRef(null);
  const [ws, setWs] = useState(null);
    const [peer, setPeer] = useState(null);
  const [organizerWindowOn, setOrganizerWindowOn] = useState(false);
  const [messages, setMessages] = useState([]);
  const [chatInput, setChatInput] = useState("");
  const [clientId, setClientId] = useState("");
  const [remoteId, setRemoteId] = useState("");
  const [connected, setConnected] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [lines, setLines] = useState([]);
  const [screenshot, setScreenshot] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [intervalId, setIntervalId] = useState(null);
  const intervalRef = useRef(null);
  const [startQuestions, setStartQuestions] = useState(false);
  const [showScore, setShowScore] = useState(false);
  const [lastQuestionProcessed, setLastQuestionProcessed] = useState(true);
  const [evaluations, setEvaluations] = useState([]);
  const [openEvaluation, setOpenEvaluation] = React.useState(false);
  const [transcripts, setTranscripts] = useState([]);
  const [fullTranscript, setFullTranscript] = useState([]);
  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
  const [interviewerStatus, setInterviewerStatus] = useState("")
  const lastSentenceTimeRef = useRef(Date.now());
  const [loading, setLoading] = useState(false);
  const [retryCount, setRetryCount] = useState(0);

  const [mouseEventState, setMouseEventState] = useState(0);
  const [leftToggleViewState, setLleftToggleViewState] = useState(false);
  const [leftToggle, setLeftToggle] = useState(true);
  const [rightToggle, setRightToggle] = useState(true);

  const [expandEngagement, setExpandEngagement] = useState(false);
  const [expandSmartNote, setExpandSmartNote] = useState(false);
  const [expandSpeechRate, setExpandSpeechRate] = useState(false);
  const [expandConversion, setxpandConversion] = useState(false);
  

  const handleMouseMoveEvent = (clientX) => {
    setMouseEventState(clientX)
  }

   // Ref to store timeout ID
  const timeoutRef = useRef(null);

   useEffect(() => {

    setLleftToggleViewState(true)
    // Clear previous timeout
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    // Set new timeout
    timeoutRef.current = setTimeout(() => {
      setLleftToggleViewState(false)
    }, 3000); // 10 seconds

    // Cleanup function
    return () => clearTimeout(timeoutRef.current);
  }, [mouseEventState]); // Runs every time 'value' changes




  const getCurrentTime = () => {
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };
  const saveInterviewProgress = () => {
    setEvaluations(selectedQuestionsRef.current);
  };
  const handleClickOpenEvaluation = () => {
    setOpenEvaluation(true);
  };
  const handleSuccessPopup = () => setOpenSuccessPopup(true);
  const handlePopup = () => {
    setOpenSuccessPopup(false)
    setTimeout(() => {
      navigate(`/admin/interviews/list/${techId}/${interviewerStatus}`);
    }, 1500);
  };
  const handleClosePopup = () => setOpenSuccessPopup(false);
  const handleCloseEvaluation = () => {
    setOpenEvaluation(false);
  };
  const mixedStreamRef = useRef(null);
  const recorderRef = useRef(null);
  const chunksRef = useRef([]); // collect audio chunks
  const getMixedStream = () => {
    const localStream = localVideo.current?.srcObject;
    const remoteStream = remoteVideo.current?.srcObject;

    if (!localStream && !remoteStream) return null;

    const context = new AudioContext();
    const destination = context.createMediaStreamDestination();

    if (localStream) {
      const source1 = context.createMediaStreamSource(localStream);
      source1.connect(destination);
    }

    if (remoteStream) {
      const source2 = context.createMediaStreamSource(remoteStream);
      source2.connect(destination);
    }

    const tracks = [];
    if (localStream) {
      const videoTrack = localStream.getVideoTracks()[0];
      if (videoTrack) tracks.push(videoTrack);
    }

    tracks.push(...destination.stream.getAudioTracks());

    return new MediaStream(tracks);
  };
  let safariRecorder = null;
  let safariAudioData = [];
  let safariAudioContext = null;

  const startRecording = () => {
    const mixedStream = getMixedStream();
    if (!mixedStream) {
      console.warn(" No stream available to record");
      return;
    }

    mixedStreamRef.current = mixedStream;
    chunksRef.current = [];

    if (typeof MediaRecorder !== "undefined") {
      console.log("▶️ Using MediaRecorder");
      const recorder = new MediaRecorder(mixedStream, { mimeType: "audio/webm" });
      recorderRef.current = recorder;

      recorder.ondataavailable = (event) => {
        if (event.data.size > 0) chunksRef.current.push(event.data);
      };

      recorder.start();
    } else {
      safariAudioContext = new (window.AudioContext || window.webkitAudioContext)();
      const source = safariAudioContext.createMediaStreamSource(mixedStream);

      const processor = safariAudioContext.createScriptProcessor(4096, 1, 1);
      safariAudioData = [];

      processor.onaudioprocess = (e) => {
        safariAudioData.push(new Float32Array(e.inputBuffer.getChannelData(0)));
      };

      source.connect(processor);
      processor.connect(safariAudioContext.destination);

      safariRecorder = { source, processor };
    }
  };

  const stopRecording = async () => {
    return new Promise((resolve) => {
      if (recorderRef.current) {
        //MediaRecorder flow
        recorderRef.current.onstop = async () => {
          const blob = new Blob(chunksRef.current, { type: "audio/webm" });
          const arrayBuffer = await blob.arrayBuffer();
          const base64Audio = btoa(
            new Uint8Array(arrayBuffer).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
          resolve(base64Audio);
        };
        recorderRef.current.stop();
      } else if (safariRecorder) {
        //Safari Web Audio fallback
        safariRecorder.processor.disconnect();
        safariRecorder.source.disconnect();

        let length = safariAudioData.reduce((acc, cur) => acc + cur.length, 0);
        let result = new Float32Array(length);
        let offset = 0;
        for (let chunk of safariAudioData) {
          result.set(chunk, offset);
          offset += chunk.length;
        }

        const wavBlob = floatToWavBlob(result, safariAudioContext.sampleRate);
        wavBlob.arrayBuffer().then((arrayBuffer) => {
          const base64Audio = btoa(
            new Uint8Array(arrayBuffer).reduce(
              (data, byte) => data + String.fromCharCode(byte),
              ""
            )
          );
          resolve(base64Audio);
        });
      } else {
        resolve(null);
      }
    });
  };

  function floatToWavBlob(float32Array, sampleRate) {
    const buffer = new ArrayBuffer(44 + float32Array.length * 2);
    const view = new DataView(buffer);

    function writeString(view, offset, string) {
      for (let i = 0; i < string.length; i++) {
        view.setUint8(offset + i, string.charCodeAt(i));
      }
    }

    // WAV header
    writeString(view, 0, "RIFF");
    view.setUint32(4, 36 + float32Array.length * 2, true);
    writeString(view, 8, "WAVE");
    writeString(view, 12, "fmt ");
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, 1, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * 2, true);
    view.setUint16(32, 2, true);
    view.setUint16(34, 16, true);
    writeString(view, 36, "data");
    view.setUint32(40, float32Array.length * 2, true);

    let offset = 44;
    for (let i = 0; i < float32Array.length; i++, offset += 2) {
      let s = Math.max(-1, Math.min(1, float32Array[i]));
      view.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }

    return new Blob([view], { type: "audio/wav" });
  };

  useEffect(() => {

    const params = new URLSearchParams(window.location.search);
    const clientFromURL = params.get("clientId");
    const roomFromURL = params.get("roomId");

    if (clientFromURL) {
      setClientId(clientFromURL);
    }
    if (roomFromURL) {
      setRemoteId(roomFromURL);
    }

    if (!clientId || connected) return;

    const wsClient = new WebSocket(`${API}/${clientId}`);

    wsClient.onopen = () => {
  console.log("✅ WebSocket connected");
    wsClient.send(JSON.stringify({ type: "hello", id: clientId }));
    setWs(wsClient); 
  };

    navigator.mediaDevices.getUserMedia({
      //  video: { width: 1280, height: 720 }, audio: true    
      video: true, audio: true
      // video: {
      //   width: { ideal: 500 },
      //   height: { ideal: 500   },
      //   frameRate: { ideal: 60 },
      // },
      // audio: {
      //   echoCancellation: true,
      //   noiseSuppression: true,
      //   sampleRate: 44100,
      // },

    }).then(stream => {
      localVideo.current.srcObject = stream;
      const newPeer = new Peer({
        initiator: true,
        trickle: false,
        stream,
      });

      newPeer.on("signal", signal => {
        safeSend(ws, { type: "signal", to: remoteId });
        // wsClient.send(JSON.stringify({ to: remoteId, type: "signal", signal }));
      });

      wsClient.onmessage = (msg) => {
        const data = JSON.parse(msg.data);
        if (data.type === "signal") {
          newPeer.signal(data.signal);
        } else if (data.type === "chat") {
          setMessages(prev => [...prev, { sender: "peer", text: data.text }]);
        }
        else if (data.type === "transcript") {
          setLines(prev => [...prev, data.line]);
        }
      };
      newPeer.on("stream", remoteStream => {
        remoteVideo.current.srcObject = remoteStream;
      });
      setPeer(newPeer);
      setConnected(true);

    });
  }, [clientId, remoteId, connected]);

  const takeScreenshot = () => {

    const video = localVideo.current;
    if (!video) return null;

    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const context = canvas.getContext("2d");
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const base64Image = canvas.toDataURL("image/jpeg");
    //return base64Image.replace(/^data:image\/[a-z]+;base64,/, "");
    console.log('base64Image', base64Image)
    return base64Image;

  };

  //   const sendTranscriptToBackend = async () => {
  //     // console.log("Transcript3", transcriptRef.current);
  //     // takeScreenshot();
  //     // console.log("Screenshot3", screenshot);
  // //  setLastQuestionProcessed(false)
  //     if (showScore) return; 
  //   const capturedImage = takeScreenshot(); // ← use return value
  //   if (!capturedImage) return;
  //   // console.log("Screenshot3", capturedImage);
  //     // console.log('quest', selectedQuestionsRef.current[selectedQuestionsRef.current.length - 1])
  //     try {
  //       // const response = await axios.post("http://127.0.0.1:8000/analyze", {
  //       const response = await axios.post(APIConstant.analyze, {
  //         question: selectedQuestionsRef.current[selectedQuestionsRef.current.length - 1]?.text || "Tell about yourself",
  //         transcript: transcriptRef.current,
  //         image_64: capturedImage,
  //       });
  //       console.log("Analysis result:", response.data);
  //     const lastQuestion = selectedQuestionsRef.current[selectedQuestionsRef.current.length - 1];

  //     if (lastQuestion) {
  //       lastQuestion.sentiment = response.data.sentiment;
  //       lastQuestion.confidence = response.data.confidence;
  //       lastQuestion.evaluation = response.data.evaluation;
  //       lastQuestion.emotion = response.data.emotion;
  //       lastQuestion.transcript = transcriptRef.current; 
  //       setLastQuestionProcessed(true);
  //       saveInterviewProgress();
  //     }
  //     } catch (err) {
  //       console.error("Error sending data:", err);
  //     }
  //   };

  useEffect(() => {
    const intervalId = setInterval(() => { }, 2000);
    intervalRef.current = intervalId;
    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);


 const startListening = (speaker) => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) { alert("Speech recognition not supported"); return; }

    const recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.continuous = true;
    recognition.interimResults = true;

    recognition.onstart = () => setIsListening(true);
    recognition.onend = () => { setIsListening(false); recognition.start(); };

    recognition.onresult = (event) => {
      let interimTranscript = "";
      for (let i = event.resultIndex; i < event.results.length; i++) {
        interimTranscript += event.results[i][0].transcript + " ";
      }
    
      for (let i = event.resultIndex; i < event.results.length; i++) {
      
        if (event.results[i].isFinal) {
            const senten = event.results[i][0].transcript.trim();
            const entry = { by: speaker, text: senten, time: getCurrentTime() };
            if (senten) {
              setLines((prev) => [...prev, entry]);
              transcriptRef.current = senten; // ⬅️ Update latest final result
          }
        }
      
          if (ws) {
        ws.send(JSON.stringify({
          type: "transcript",
          to: remoteId,
          line: entry,
        }));
      }
      }
    };
    recognition.onerror = (e) => console.error("Speech error:", e.error);
    recognition.start();
    recognitionRef.current = recognition;
  };



useEffect(() => {
  if (organizerWindowOn) {
    if (user === "organizer") startListening("organizer");
    else if (user === "attendees") startListening("attendees");
  }
}, [organizerWindowOn, user]);
  // useEffect(() => {
  //   const id = setInterval(() => {
  //     if (!showScore) {
  //       sendTranscriptToBackend();
  //     } else {
  //       sendTranscriptToBackend().finally(() => clearInterval(id));
  //     }
  //   }, 3000);

  //   return () => clearInterval(id);
  // }, [showScore]);
  // useEffect(() => {
  //   setInterval(() => {
  //     console.log("Interval", true)
  //     sendTranscriptToBackend()
  //   }, 3000);
  // }, []) 

  if (!clientId || !remoteId) {
    return (
      <div className="h-screen w-screen bg-gray-950 text-white flex flex-col items-center justify-center gap-4 p-6">
        <h1 className="text-2xl font-bold mb-4">Enter your details to start a call</h1>
        <input
          type="text"
          placeholder="Your ID"
          value={clientId}
          onChange={(e) => setClientId(e.target.value)}
          className="p-2 rounded-md bg-gray-800 w-full max-w-sm focus:outline-none"
        />
        <input
          type="text"
          placeholder="Remote ID to connect"
          value={remoteId}
          onChange={(e) => setRemoteId(e.target.value)}
          className="p-2 rounded-md bg-gray-800 w-full max-w-sm focus:outline-none"
        />
        <button
          onClick={() => setConnected(false)} // Triggers useEffect
          className="mt-2 bg-blue-600 hover:bg-blue-500 px-6 py-2 rounded-md"
        >
          Connect
        </button>
      </div>
    );
  }

  const handleChildClick = () => {
    setOrganizerWindowOn(true)
  };




  return (

    <div className={styles.appContainer}>

      {/* HEADER */}
      {/* <header className={styles.navbar}>
        <img src={Images.OKO} alt="Logo" className={styles.okologo} width="76" />
      </header> */}


      {/* Video Area */}
      <div className={`${styles.videoControlWrapper} flex-1 relative flex flex-col items-center justify-center px-6 py-8`}>

        <div className='w-full h-screen'>
          <video
            style={{ display: 'none' }}
            ref={localVideo}
            muted
            autoPlay
            playsInline
            className='w-full h-full object-cover'
          />
          {/* <img src={Images.VIDEOCALL} alt="Video Call" className={styles.videoCallImage}/> */}
        </div>

        {/* Control Bar */}

      </div>

      <div className={styles.videoContainer}>
        <JitsiMeeting onButtonClick={handleChildClick} mouseEventTriggered={handleMouseMoveEvent} chatOpen={rightToggle}/>
        {/* {(organizerWindowOn && user === 'organizer') &&
          //  {organizerWindowOn && 
          <aside className={styles.sidebar}>
            
            {startQuestions === false && loading && (
              <div className={styles.startQuestion}>
                <div className="flex flex-col items-center space-y-4">
                  <img
                    src={Images.SPINNER}
                    alt="Loading..."
                    className="w-10 h-10 animate-spin"
                    style={{ margin: 'auto', height: '30px', width: '30px' }}
                  />
                
                </div>
              </div>
            )}
          </aside>
        } */}

        {/* <Dialog open={openEvaluation} onClose={handleCloseEvaluation}    >
          <InterviewEvaluation handleSuccessPopup={handleSuccessPopup} handleCloseEvaluation={handleCloseEvaluation} fullTranscript={fullTranscript} questionLen={questionLen} evaluations={evaluations} interviewId={interviewId} setInterviewerStatus={setInterviewerStatus} />
        </Dialog> */}

          {/* Engagement */}
          {organizerWindowOn  &&
          <div className={`${styles.engagementWrapper} ${leftToggle ? styles.toggleOn : styles.toggleOff}  ${expandEngagement ? styles.expand : ""} `}>
            <div className={styles.engContainer}>
              <h5>Engagement</h5>
              <ul className={styles.collapseBox}>
                {expandEngagement
                  ? <li className={styles.closeIco}><a onClick={() => setExpandEngagement(false)}><img src={Images.CLOSE_WHITE} alt="Close" width="10"/></a></li>
                  : <li className={styles.expandIco}><a onClick={() => setExpandEngagement(true)}><img src={Images.EXPAND} alt="Expand" width="14"/></a></li>
                }
              </ul>
              <ul className={styles.engList}>
                <li><span>Suresh</span>, Try to slow down. </li>
                <li><span>Bala</span>, You’ve been speaking for 10 mins straight</li>
              </ul>
            </div>
          </div>
          }

          {organizerWindowOn  &&
            <span onClick={() => setLeftToggle(!leftToggle)} className={`${styles.leftToggleButton} ${leftToggleViewState ? styles.show : ""} ${leftToggle ? styles.toggleOn : styles.toggleOff}`}></span>
          }
          {organizerWindowOn  &&
            <span onClick={() => setRightToggle(!rightToggle)} className={`${styles.rightToggleButton} ${leftToggleViewState ? styles.show : ""} ${rightToggle ? styles.toggleOn : styles.toggleOff}`}></span>
          }

          {/* Smart Note */}
          {organizerWindowOn  &&
          <div className={`${styles.smartNoteWrapper} ${leftToggle ? styles.toggleOn : styles.toggleOff} ${expandSmartNote ? styles.expand : ""}`}>
            <div className={styles.smartNoteContainer}>
            <h5>Smart Note</h5>
            <ul className={styles.collapseBox}>
                
                {expandSmartNote 
                  ? <li className={styles.closeIco}><a onClick={() => setExpandSmartNote(false)}><img src={Images.CLOSE_WHITE} alt="Close" width="10"/></a></li>
                  : <li className={styles.expandIco}><a onClick={() => setExpandSmartNote(true)}><img src={Images.EXPAND} alt="Expand" width="14"/></a></li>
                }
              </ul>
            <ul className={styles.smartNoteList}>
              <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</li>
            </ul>
            </div>
          </div>
          }

          {/* Speech Rate */}
          {organizerWindowOn  &&
          <div className={`${styles.speechRateWrapper} ${leftToggle ? styles.toggleOn : styles.toggleOff} ${expandSpeechRate ? styles.expand : ""}`}>
            <div className={styles.speechRateContainer}>
            <h5>Speech Rate</h5>
            <ul className={styles.collapseBox}>
              {expandSpeechRate 
                ? <li className={styles.closeIco}><a onClick={() => setExpandSpeechRate(false)}><img src={Images.CLOSE_WHITE} alt="Close" width="10"/></a></li>
                : <li className={styles.expandIco}><a onClick={() => setExpandSpeechRate(true)}><img src={Images.EXPAND} alt="Expand" width="14"/></a></li>
              } 
            </ul>
            <ul className={styles.speechRateList}>
              <li>
                <span>Suresh</span> 
                <div className={`${styles.progressBar} ${styles.disruptive}`} style={{ width: '35%' }}>
                  <div className={`${styles.momentum}`}>Disruptive</div>
                  <div className={styles.rate}>35%</div>
                </div>
              </li>
              <li>
                <span>Karthi</span> 
                <div className={`${styles.progressBar} ${styles.distracted}`} style={{ width: '45%' }}>
                  <div className={`${styles.momentum}`}>Distracted</div>
                  <div className={styles.rate}>45%</div>
                </div>
              </li>
              <li>
                <span>Bala</span> 
                <div className={`${styles.progressBar} ${styles.attentive}`} style={{ width: '55%' }}>
                  <div className={`${styles.momentum}`}>Attentive</div>
                  <div className={styles.rate}>55%</div>
                </div>
              </li>
              <li>
                <span>Selva</span> 
                <div className={`${styles.progressBar} ${styles.participating}`} style={{ width: '60%' }}>
                  <div className={`${styles.momentum}`}>Participating</div>
                  <div className={styles.rate}>60%</div>
                </div>
              </li>
              <li>
                <span>Pooja</span> 
                <div className={`${styles.progressBar} ${styles.contributing}`} style={{ width: '65%' }}>
                  <div className={`${styles.momentum}`}>Contributing</div>
                  <div className={styles.rate}>65%</div>
                </div>
              </li>
              <li>
                <span>Chandni</span> 
                <div className={`${styles.progressBar} ${styles.owning}`} style={{ width: '95%' }}>
                  <div className={`${styles.momentum}`}>Owning</div>
                  <div className={styles.rate}>95%</div>
                </div>
              </li>
            </ul>
            </div>
          </div>
          }

        <Popup open={openSuccessPopup}
          message="Your request has been submitted"
          title="Thank You"
          handleClose={handleClosePopup}
          handleConfirm={() => handlePopup()} type="success" />



        {organizerWindowOn &&
          <aside className={`${styles.chatCont} ${rightToggle ? styles.toggleOn : styles.toggleOff} ${expandConversion ? styles.expand : ""}`}>
            <div className={styles.chatContainer}>
            <ul className={styles.collapseBox}>
              {expandConversion 
                ? <li className={styles.closeIco}><a onClick={() => setxpandConversion(false)}><img src={Images.CLOSE_WHITE} alt="Close" width="10"/></a></li>
                : <li className={styles.expandIco}><a onClick={() => setxpandConversion(true)}><img src={Images.EXPAND} alt="Expand" width="14"/></a></li>
              } 
            </ul>

            <div className={styles.transcript}>
              <div className={styles.chats}>
                <h3 className={styles.fixed}>Conversation</h3>
                <div className={styles.chatcontainer}>
                  <div className={styles.chatmessages} id="chatMessages">
                    <ul>
                      {lines.map((line, index) => {
                        const prevLine = lines[index - 1];
                        const showHeader = !prevLine || prevLine.by !== line.by;

                        return (
                          <li key={`line-${index}`} className={styles.alignL}>
                            {showHeader && (
                              <span className={styles.profileImg}>
                                <img src={Images.PROFILE} alt={line.by} />
                              </span>

                            )}

                            <div className={styles.chatMessages}>
                              {showHeader && (
                                <div style={{ display: 'flex', gap: '5px' }}><h5>{line.by === "organizer" ? "Organizer" : "Attendees"}</h5><span className={styles.time}>{line.time}</span></div>
                              )}
                              <p className={!showHeader && `${styles.ml35}`}>{line.text}</p>

                            </div>
                          </li>
                        );
                      })}
                      {/* Show current live transcript being spoken */}
                      {lines.length == 0 && (
                        <li className={styles.alignL}>
                          <span className={styles.profileImg}>
                            <img src={Images.PROFILE} alt="live" />
                          </span>
                          <div className={styles.chatMessages}>
                            <h5>{clientId}</h5>
                            <p className="animate-pulse">Waiting for speech...</p>
                          </div>
                        </li>
                      )}
                      <div ref={chatEndRef} />
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </aside>
        }

        {/* {organizerWindowOn &&
          <div className={styles.partEmotionCont}>
            <ul>
              <li>
                <img src={Images.HAPPY_ACTIVE} alt="emotion" width="30" />
              </li>
            </ul>
          </div>
        } */}
        {/* {organizerWindowOn &&
          
          <AskOko />
          
        } */}


      </div>

    </div>

  );
};

export default StartMeetingSession;
